import { render, staticRenderFns } from "./ApproveFranchiseVersionBtn.vue?vue&type=template&id=5194b84d&scoped=true&"
import script from "./ApproveFranchiseVersionBtn.vue?vue&type=script&lang=js&"
export * from "./ApproveFranchiseVersionBtn.vue?vue&type=script&lang=js&"
import style0 from "./ApproveFranchiseVersionBtn.vue?vue&type=style&index=0&id=5194b84d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5194b84d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VButton: require('/home/circleci/repo/components/VButton.vue').default})
